import React from "react";
import NetworkError from "components/NetworkError/NetworkError";
import Header from "./Header";
import styles from "./RestaurantLayout.module.css";

const RestaurantLayout = ({ left, right, error, loading, goBack = null }) => (
  <>
    <Header goBack={goBack} loading={loading} />
    {error && <NetworkError />}
    <div className={styles.restaurantLayout}>
      <div className={styles.RestaurantLeft}>{left}</div>
      <div className={styles.RestaurantRight}>{right}</div>
    </div>
  </>
);

export default RestaurantLayout;
